var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_585_49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5013 14.3453L8.60133 8.53126L15.1423 1.99126L11.5013 14.3453ZM2.15433 4.99926L14.5093 1.36326L7.96833 7.89926L2.15433 4.99926ZM0.82033 4.46226C0.734475 4.48716 0.658134 4.5374 0.601298 4.6064C0.544461 4.6754 0.509776 4.75994 0.50178 4.84898C0.493784 4.93801 0.51285 5.02739 0.556483 5.10541C0.600116 5.18343 0.666285 5.24647 0.74633 5.28626L7.72533 8.77526L11.2143 15.7533C11.2541 15.8333 11.3172 15.8995 11.3952 15.9431C11.4732 15.9867 11.5626 16.0058 11.6516 15.9978C11.7407 15.9898 11.8252 15.9551 11.8942 15.8983C11.9632 15.8415 12.0134 15.7651 12.0383 15.6793L16.4823 0.569264C16.5049 0.492677 16.5063 0.411435 16.4865 0.334089C16.4668 0.256744 16.4265 0.186157 16.37 0.12976C16.3135 0.0733628 16.2429 0.0332419 16.1655 0.0136205C16.0881 -0.00600087 16.0069 -0.00439663 15.9303 0.0182644L0.82033 4.46226Z",
    fill: "#464646"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_585_49"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15.999,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.4256dae62359aa2e41827c1b1731356c.svg";
export { ForwardRef as ReactComponent };